<template>
  <NuxtLayout
    :name="isExistCountryMap(country) ? 'country-large' : 'country-small'"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div class="main top">
        <div class="title__wrap">
          <SectionTitle
            :title="`${countryName}各地の天気予報`"
            is-h1
          />
          <ShareButton
            category="COUNTRY"
            :title="title"
          />
        </div>
        <CountryTopMap
          v-if="status === 'success' && isExistCountryMap(country)"
          :country="country"
          :area="areaId"
          :country-name="countryName"
          :array-map-point="arrayMapPoint"
          :array-other-point="arrayOtherPoint"
        />
        <CountryTopTable
          v-if="status === 'success' && !isExistCountryMap(country)"
          :country="country"
          :country-name="countryName"
          :area="areaId"
          :array-other-point="arrayOtherPoint"
        />
        <RankingPoint
          v-if="!isExistCountryMap(country)"
          target-display-type="country"
          :target-id="`/${areaId}/${country}/`"
          target-point-type="city"
          :now="now"
        />
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <CountryTopTable
          v-if="status === 'success' && isExistCountryMap(country)"
          :country="country"
          :country-name="countryName"
          :area="areaId"
          :array-other-point="arrayOtherPoint"
        />
        <RankingPoint
          v-if="isExistCountryMap(country)"
          target-display-type="country"
          :target-id="`/${areaId}/${country}/`"
          target-point-type="city"
          :now="now"
        />
        <div
          v-if="!isWebViewFlag && existCityRanking"
          id="ads-btf5-pc"
          class="ads-btf5-pc"
        />
        <div
          v-if="existCityRanking && isExistCountryMap(country)"
          id="ads-btf4-sp-small-height"
          class="ads-btf4-sp"
        />
        <CommonSpotList
          v-if="statusLandmark === 'success' && arrayLandmark.length > 0"
          :title="`${countryName}の観光地`"
          :contents="arrayLandmark"
        />
        <RankingPoint
          v-if="statusLandmark === 'success' && arrayLandmark.length > 0"
          target-display-type="country"
          :target-id="`/${areaId}/${country}/`"
          target-point-type="landmark"
          :now="now"
        />
        <CommonSpotList
          v-if="statusAirport === 'success' && arrayAirport.length > 0"
          :title="`${countryName}の空港`"
          :contents="arrayAirport"
        />

        <template v-if="pageAdType === '10'">
          <HorizontalStackAd
            v-if="!isWebViewFlag"
            left-ad-id="ads-btf2-left-pc"
            right-ad-id="ads-btf2-right-pc"
          />
          <div
            id="ads-btf1-sp"
            class="ads-btf1-sp"
          />
        </template>

        <RadarLinkCard
          :link="`/onebox/tenki/world/radar/${areaId}/${country}/`"
          :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/thumb/area_${areaId}/prec.webp`"
          :target-area="countryName"
        />

        <template v-if="pageAdType === '20'">
          <HorizontalStackAd
            v-if="!isWebViewFlag"
            left-ad-id="ads-btf2-left-pc"
            right-ad-id="ads-btf2-right-pc"
          />
        </template>

        <CommonCountryList
          is-country
        />

        <template v-if="pageAdType === '30'">
          <HorizontalStackAd
            v-if="!isWebViewFlag"
            left-ad-id="ads-btf2-left-pc"
            right-ad-id="ads-btf2-right-pc"
          />
        </template>

        <template v-if="pageAdType === '10'">
          <HorizontalStackAd
            v-if="!isWebViewFlag"
            left-ad-id="ads-btf4-left-pc"
            right-ad-id="ads-btf4-right-pc"
          />
          <div
            id="ads-btf2-sp"
            class="ads-btf2-sp"
          />
        </template>
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'
import countryIdList from '~/data/table/country_id_list.json'
import countryFamousPoint from '~/data/table/country_famous_point.json'

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()

const route = useRoute()
const areaId = route.params.area
const country = route.params.country
const now = dayjs().unix()

// const existCityRanking = ref(true)

if (!(`/${areaId}/${country}/` in countryIdList)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid'
  })
}
const countryName = countryIdList[`/${areaId}/${country}/`].country_ja

const targetMapPoint = Object.keys(countryFamousPoint).includes(country) ? countryFamousPoint[country] : []
const paramsOtherPoint = {
  country: country,
  targetPointType: 'city'
}
if (targetMapPoint.length > 0) {
  paramsOtherPoint.excludePointId = targetMapPoint.map((v) => v.point_id).join(',')
}
const { data: otherPoint } = await useFetch('/api/point/list', {
  params: paramsOtherPoint,
  transform: (data_) => {
    return data_.map((v) => {
      return {
        text: v.point_ja,
        point_id: v.point_id,
        cc: v.cc
      }
    })
  }
})
const targetMapPointExcludeCountry = targetMapPoint.filter((v) => !v.isCountry)
const concatPoint = targetMapPointExcludeCountry.concat(otherPoint.value)
const { data: wxInfo, status } = await useFetch(`/api/point/weather?pointId=${concatPoint.map((v) => v.point_id).join(',')}`, {
  transform: (data_) => {
    return formatMajorCityWeather(concatPoint.map((v) => v.point_id), data_, now)
  }
})
const arrayMapPoint = targetMapPoint.map((v) => {
  return {
    key: v.key,
    text: v.text,
    point_id: v.point_id,
    positionX: v.positionX,
    positionY: v.positionY,
    isCountry: v?.isCountry ?? false,
    areaId: v?.areaId,
    wx: wxInfo.value[v.point_id]?.wx,
    maxTemp: wxInfo.value[v.point_id]?.maxt,
    minTemp: wxInfo.value[v.point_id]?.mint
  }
})
const arrayOtherPoint = otherPoint.value.map((v) => {
  return {
    text: v.text,
    point_id: v.point_id,
    wx: wxInfo.value[v.point_id].wx,
    maxTemp: wxInfo.value[v.point_id].maxt,
    minTemp: wxInfo.value[v.point_id].mint
  }
})

// Landmark
const paramsLandmark = {
  country,
  targetPointType: 'landmark'
}
if (targetMapPoint.length > 0) {
  paramsLandmark.excludePointId = targetMapPoint.map((v) => v.point_id).join(',')
}
const { data: arrayLandmark, status: statusLandmark } = await useFetch('/api/point/list', {
  params: paramsLandmark,
  transform: (data_) => {
    return data_.map((v) => {
      return {
        text: v.point_ja,
        href: v.point_id
      }
    })
  }
})
// Airport
const paramsAirport = {
  country,
  targetPointType: 'airport'
}
if (targetMapPoint.length > 0) {
  paramsAirport.excludePointId = targetMapPoint.map((v) => v.point_id).join(',')
}
const { data: arrayAirport, status: statusAirport } = await useFetch('/api/point/list', {
  params: paramsAirport,
  transform: (data_) => {
    return data_.map((v) => {
      return {
        text: v.point_ja,
        href: v.point_id
      }
    })
  }
})

// ランキング情報有無
const { data: rankingSetting } = await useFetch('/api/ranking/setting')
const existCityRanking = computed(() => {
  if (!rankingSetting.value) return false
  if (!rankingSetting.value.country) return false
  if (!rankingSetting.value.country[`/${areaId}/${country}/`]) return false
  if (!rankingSetting.value.country[`/${areaId}/${country}/`].includes('city')) return false
  return true
})

const pageAdType = computed(() => {
  if (isExistCountryMap(country)) return '10'
  if (arrayLandmark.length > 0 || arrayAirport.length > 0) return '20'
  return '30'
})
const breadcrumb = [
  {
    text: '世界天気',
    link: `${runtimeConfig.public.hostDomain}/onebox/tenki/world/`
  },
  {
    text: `${areaLabelMap[areaId]}`,
    link: `${runtimeConfig.public.hostDomain}/onebox/tenki/world/${areaId}/`
  },
  {
    text: `${countryName}`
  }
]
const title = `${countryName}の天気 - ウェザーニュース`
useCommonHead({
  title,
  description: `【${countryName}各地の2週間先までの天気予報】${countryIdList[`/${areaId}/${country}/`]?.td_city_list}など旅行や出張の天気も簡単検索！各地の雨雲レーダーは48時間先まで確認できます。天気に関する全てのサポートは【予報精度No.1ウェザーニュース】にお任せください。`,
  keywords: `${countryName},2週間,当たる`,
  appTitle: areaLabelMap[areaId],
  appCountKey: route.path.toLowerCase(),
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_color@2x.png`
})
useCommonJsonld({
  breadcrumb: breadcrumb
})
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  &.top {
    gap: 10px;
  }
}
.main:has(.worldWeather) {
  gap: 10px;
}
.title__wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 5px;
  flex-wrap: wrap;
}

.ads-btf5-pc {
  min-height: 50px;
  margin: 0px auto;
}
.ads-btf4-sp {
  min-height: 50px;
  margin: 0px auto;
}
.ads-btf1-sp {
  min-height: 50px;
  margin: 0px auto;
}
.ads-btf2-sp {
  min-height: 50px;
  margin: 0px auto;
}
</style>
